<template>
  <div class="cn-products-list">
    <div v-if="loading" class="cn-products-list__list">
      <div v-for="i in perRow * 2" :key="i">
        <ProductCardSkeleton />
      </div>
    </div>
    <div v-else-if="!loading && products?.length !== 0">
      <div
        class="cn-products-list__list"
        itemscope
        itemtype="http://schema.org/ItemList"
      >
        <ProductCard
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </div>
      <UiPagination
        v-if="!loading && totalPagesCount !== undefined && totalPagesCount > 1"
        :current-page="currentPage"
        :page-count="totalPagesCount"
      />
    </div>
    <SearchNotFound v-else />
  </div>
</template>

<script setup lang="ts">
import SearchNotFound from '@/components/SearchNotFound';
import ProductCardSkeleton from '@/components/ProductCardSkeleton';
import ProductCard from '@/components/ProductCard';
import UiPagination from '@/components/ui/UiPagination';

interface Props {
  loading?: boolean;
  products: any[];
  perRow?: number;
  totalPagesCount?: number;
  currentPage?: number | string;
}
withDefaults(defineProps<Props>(), {
  loading: false,
  perRow: 3,
  totalPagesCount: 0,
  currentPage: 1,
});

// const grid = new Map([
//   [3, 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3'],
//   [4, 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4'],
// ]);
// const gridClasses = computed(() => {
//   return grid.get(props.perRow);
// });
</script>

<style lang="scss">
.cn-products-list {
  &__list {
    grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));
    row-gap: var(--size-3xl);
    column-gap: var(--size-xl);
    display: grid;
  }
}
</style>
